/* eslint-disable no-new-object */
import { ConfirmClientCodeResponseModel } from "../../request/myHealthyAdvantageApi";

export abstract class ClientInfoState {
  public static get(): string | undefined {
    return localStorage.getItem("clientInfo") ?? undefined;
  }

  public static set(value: ConfirmClientCodeResponseModel) {
    localStorage.setItem("clientInfo", JSON.stringify(value));
  }

  public static toJson(): ConfirmClientCodeResponseModel | undefined {
    const clientInfo = this.get();
    const client = clientInfo ? new Object(JSON.parse(clientInfo)) : {};
    return client;
  }

  public static getCode(): string | undefined {
    const clientCode = this.toJson()?.clientCode;
    return clientCode ?? undefined;
  }

  public static isDemoClient() {
    const clientCode = this.getCode();
    return ["HADEMO", "ACME"].includes(clientCode?.toUpperCase() ?? "");
  }

  public static clear() {
    localStorage.removeItem("clientInfo");
  }
}
